import React from "react";
import styled, { withTheme } from "styled-components/macro";
// import { darken } from "polished";
// import { Search as SearchIcon } from "react-feather";
// import { useTranslation } from "react-i18next";

import {
  Grid,
  // InputBase,
  AppBar as MuiAppBar,
  IconButton as MuiIconButton,
  Toolbar,
  Card,
  CardContent,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Menu as MenuIcon } from "@mui/icons-material";

import NavbarNotificationsDropdown from "./NavbarNotificationsDropdown";
import NavbarUserDropdown from "./NavbarUserDropdown";
import NavbarFeedbackButton from "./NavbarFeedbackButton";
import NavbarTermsButton from "./NavbarTermsButton";
import DealerSearchInput from "../planning/dealerProfile/DealerSearchInput";
import { borderRadius } from "polished";

const AppBar = styled(MuiAppBar)`
  background: ${(props) => props.theme.header.background};
  color: ${(props) => props.theme.header.color};
`;

const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
`;

const DealerSearchInputStyled = styled(DealerSearchInput)`
  background-color: ${(props) =>
    props.theme.name === "DARK" ? "transparent" : "white"} !important;
`;

// const Search = styled.div`
//   border-radius: 2px;
//   background-color: ${(props) => props.theme.header.background};
//   display: none;
//   position: relative;
//   width: 100%;

//   &:hover {
//     background-color: ${(props) => darken(0.05, props.theme.header.background)};
//   }

//   ${(props) => props.theme.breakpoints.up("md")} {
//     display: block;
//   }
// `;

// const SearchIconWrapper = styled.div`
//   width: 50px;
//   height: 100%;
//   position: absolute;
//   pointer-events: none;
//   display: flex;
//   align-items: center;
//   justify-content: center;

//   svg {
//     width: 22px;
//     height: 22px;
//   }
// `;

// const Input = styled(InputBase)`
//   color: inherit;
//   width: 100%;

//   > input {
//     color: ${(props) => props.theme.header.search.color};
//     padding-top: ${(props) => props.theme.spacing(2.5)};
//     padding-right: ${(props) => props.theme.spacing(2.5)};
//     padding-bottom: ${(props) => props.theme.spacing(2.5)};
//     padding-left: ${(props) => props.theme.spacing(12)};
//     width: 160px;
//   }
// `;

const Navbar = ({ onDrawerToggle, openFeedback }) => {
  // const { t } = useTranslation();

  const [selectValue, setSelectValue] = useState(null);

  return (
    <React.Fragment>
      <AppBar position="sticky" elevation={0}>
        <Toolbar>
          <Grid container alignItems={"top"}>
            <Grid item xs={4}>
              <IconButton
                color="inherit"
                aria-label="Open drawer"
                onClick={onDrawerToggle}
                size="large"
              >
                <MenuIcon />
              </IconButton>
            </Grid>
            {/* <Grid item>
              <Search>
                <SearchIconWrapper>
                  <SearchIcon />
                </SearchIconWrapper>
                <Input placeholder={t("Search")} />
              </Search>
            </Grid> */}
            <Grid
              container
              item
              alignItems={"top"}
              justifyContent={"end"}
              xs={8}
              sx={{ overflow: "hidden" }}
            >
              <div
                style={{
                  border: "5px",
                  borderRadius: "5px",
                  width: "25%",
                }}
              >
                <DealerSearchInputStyled
                  selectValue={selectValue}
                  setSelectValue={setSelectValue}
                  newTab
                />
              </div>
              <NavbarTermsButton />
              <NavbarFeedbackButton onClick={openFeedback} />
              <NavbarNotificationsDropdown />
              <NavbarUserDropdown />
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </React.Fragment>
  );
};

export default withTheme(Navbar);
